import { httpResource } from 'core/resources/httpResource';
import { BaseRestResource } from '@snap-alex/domain-js';
import { costSettingsResourceUrl } from '../constants/ResourceUrls';

class CostSettingsResource extends BaseRestResource {}

export const costSettingsResource = new CostSettingsResource(httpResource, costSettingsResourceUrl);
